module.exports = __webpack_public_path__ + "static/media/header-banner.19f517c0.png";